import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import API_BASE_URL from "../config/apiConfig";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  // ✨ FIX: Wrap checkSession in useCallback and move it outside the useEffect
  const checkSession = useCallback(async () => {
    try {
      const baseURL = API_BASE_URL;
      const res = await fetch(`${baseURL}/api/auth/me`, {
        credentials: "include",
      });

      if (res.status === 403) {
        const data = await res.json().catch(() => ({}));
        if (data.errorType === 'account_suspended' || data.errorType === 'account_deleted') {
          localStorage.clear();
          sessionStorage.clear();
          setUser(null);
          window.location.href = `/log-in?account_error=${data.errorType}`;
          return; 
        }
      }

      if (res.ok) {
        const data = await res.json();
        if (data && (data.email || data._id || data.userId)) {
          setUser(data); 
        } else {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("Auth check failed:", error);
      setUser(null);
    } finally {
      setIsAuthLoading(false);
    }
  }, []); // Empty dependency array ensures it doesn't recreate infinitely

  // Run on initial load
  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = (userData) => setUser(userData);
  const logout = () => setUser(null);

  return (
    <AuthContext.Provider value={{ user, isAuthLoading, login, logout, checkSession }}>
      {children}
    </AuthContext.Provider>
  );
};